export default __webpack_public_path__ + "img/1b3bf951f12dc883bd86cdf2eb60653e.png";